<template lang="pug">
div
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
    )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="showButtonOrdemServico",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro"
    @atualizarFiltro="atualizarFiltro"
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @salvarMatricula="salvarMatricula"
    @enviarProcessos="enviarProcessos"
  )
  span.padding-left(v-if="showButtonOrdemServico") {{ 'Processos Selecionados: ' + idsProcessos.length }}
</template>

<script>
import { mapActions } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalAvocar from '@/screens/analise/components/modal/AppModalAvocar'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import AppModalAssinarTitulo from '@/screens/analise/components/AppModalAssinarTitulo'
import AppModalSolicitarRetificacao from '@/screens/analise/components/modal/AppModalSolicitarRetificacao'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalAvocar,
    ModalTrocarResponsavel,
    AppModalAssinarTitulo,
    AppModalSolicitarRetificacao
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('AGUARDANDO_ENVIO_REGISTRO_CARTORIO'),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      setoresInfoVencimento: [ 'GAC', 'GEO', 'GCG', 'CGIR', 'DEAF', 'GDA', 'GRF', 'GAM', 'GEA', 'DJ', 'CDI', 'CPAV', 'GP', 'GRF_CAF',
        'GCG_CGIR'],
      processosSelecionados: [],
      showModalResponsavel: false,
      disabledAnalisar: false,
      showModalVisualizarProcesso: false,
      solicitarRetificacao: false,
      showModalAssinatura: false,
      showModalAvocar: false,
      processoTrocado: null,
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      setorSelecionado: null,
      protocolo: null,
      idsProcessosAssinatura: [],
      idsProcessos: [],
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.AGUARDANDO_ENVIO_REGISTRO_CARTORIO || [],
        filtroResponsavel: filtro?.filtroResponsavel?.AGUARDANDO_ENVIO_REGISTRO_CARTORIO || [],
        filtroReceita: filtro?.filtroReceita?.AGUARDANDO_ENVIO_REGISTRO_CARTORIO || [],
        filtroMunicipio: filtro?.filtroMunicipio?.AGUARDANDO_ENVIO_REGISTRO_CARTORIO || []
      },
      colunas: [
        { id: 0, titulo: 'Matrícula', propriedade: 'dadosCartorio.matricula', ordem: 1, acoes: [], type: 'icone' },
        { id: 1, titulo: 'Processo', propriedade: 'dadosCartorio.numeroProcesso', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome do Interessado', propriedade: 'dadosCartorio.nomeInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'CPF', propriedade: 'dadosCartorio.cpfInteressado', ordem: 4, acoes: [] },
        { id: 12, titulo: 'Nome do cônjuge/companheiro(a)', propriedade: 'dadosCartorio.nomeConjuge', ordem: 13, acoes: [] },
        { id: 13, titulo: 'CPF do cônjuge/companheiro(a)', propriedade: 'dadosCartorio.cpfConjuge', ordem: 14, acoes: [] },
        { id: 16, titulo: 'Endereço', propriedade: 'dadosCartorio.endereco', ordem: 17, acoes: [] },
        { id: 18, titulo: 'Bairro', propriedade: 'dadosCartorio.bairro', ordem: 19, acoes: [] },
        { id: 20, titulo: 'Quadra', propriedade: 'dadosCartorio.quadra', ordem: 21, acoes: [] },
        {
          id: 23, titulo: 'Ações', propriedade: 'tipo', ordem: 24, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Informar Dados', icone: 'fa-file', codigo: 'INFORMAR_DADOS', ordem: 1, show: this.showInformarDados, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 2, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso }
          ]
        }
      ],
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false
    }
  },

  async created () {
    this.init()
  },

  computed: {
    showButtonOrdemServico () {
      return false
    }
  },

  methods: {
    ...mapActions({
      saveDadosCartorio: 'despacho/saveDadosCartorio'
    }),
    INFORMAR_DADOS: async (_this, { item }) => {
      if (!this.disabledAnalisar) {
        this.disabledAnalisar = true
        _this.$router.push({
          name: 'ENVIAR_DADOS_CARTORIO',
          params: {
            idProcesso: item.id
          }
        })
        this.disabledAnalisar = false
      }
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    async salvarMatricula (dados) {
      await this.saveDadosCartorio(dados).then(() => {
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.DADOS_SALVOS_SUCESSO)
        this.init()
      })
    },
    encurtarTexto (value) {
      return value ? value.slice(0, 13) + '...' : '--'
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

.padding-left {
  padding-left: 25px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaAguardandoRegistroCartorio.vue